import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.migrations');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-migrations',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.migrations/view.scss */
/* src/app/page.migrations/view.scss: no such file or directory */`],
})
export class PageMigrationsComponent implements OnInit {
    public activeStatus: string = 'all';

    public records: any[] = [
        { file: 'ETCH_CD_MEASURE_0913.xlsx', equipment: 'ETCH-12', destination: 'CD 계측 저장소', rows: '31,240', size: '22.6 MB', status: 'processing', progress: 84, time: '15:42:18' },
        { file: 'CMP_THICKNESS_LOT_B24.xlsx', equipment: 'CMP-07', destination: '두께 분석 저장소', rows: '26,112', size: '19.3 MB', status: 'success', progress: 100, time: '15:31:04' },
        { file: 'WAFER_MAP_LINE_05.xlsx', equipment: 'INSPECT-05', destination: '수율 분석 저장소', rows: '42,908', size: '34.8 MB', status: 'success', progress: 100, time: '15:18:56' },
        { file: 'PHOTO_OVERLAY_PM_02.xlsx', equipment: 'PHOTO-18', destination: 'Overlay 저장소', rows: '12,440', size: '9.1 MB', status: 'success', progress: 100, time: '14:57:22' },
        { file: 'DIFFUSION_TEMP_TRACE.xlsx', equipment: 'DIFF-09', destination: '공정 이력 저장소', rows: '18,706', size: '13.8 MB', status: 'success', progress: 100, time: '14:35:10' },
        { file: 'CVD_FILM_UNIFORMITY.xlsx', equipment: 'CVD-04', destination: '막질 분석 저장소', rows: '10,382', size: '8.6 MB', status: 'failed', progress: 46, time: '14:12:49' }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public get visibleRecords() {
        if (this.activeStatus === 'all') return this.records;
        return this.records.filter((record: any) => record.status === this.activeStatus);
    }

    public statusLabel(status: string) {
        const labels: any = { success: '성공', processing: '진행 중', failed: '실패' };
        return labels[status] || status;
    }

    public statusClass(status: string) {
        const classes: any = {
            success: 'border-emerald-200 bg-emerald-50 text-emerald-700',
            processing: 'border-cyan-200 bg-cyan-50 text-cyan-700',
            failed: 'border-rose-200 bg-rose-50 text-rose-700'
        };
        return classes[status] || 'border-slate-200 bg-slate-50 text-slate-600';
    }
}

export default PageMigrationsComponent;